require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es7.symbol.observable.js
// module id = 918
// module chunks = 1 2 3 4 5 17 20 21 22 25 26 27 28 29 30